import React, { useState, useRef, useEffect } from 'react';
import { 
    InputGroup, Input, InputRightAddon, InputRightElement, Button, ButtonGroup, Text, VStack, Icon, IconButton,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, Link
} from '@chakra-ui/react';
import { MdDownload, MdCopyAll, MdOpenInBrowser } from 'react-icons/md';
import { QRCodeCanvas } from 'qrcode.react';
import { encrypt, decrypt } from '../../../utils/crypto';

function ShowQRCodeModal({ 
    initialRef, isOpen, onClose, patientDetail, patientResultDetail
}) {
    const mounted = useRef();
    const [ displayPatientResultUrl, setDisplayPatientResultUrl ] = useState("");
    const [ shortDisplayPatientResultUrl, setShortDisplayPatientResultUrl ] = useState("");
    const [ isCopied, setIsCopied ] = useState(false);

    useEffect(() => {
        if(!mounted.current) {
            const cipherText = encrypt(patientResultDetail.id + "", process.env.REACT_APP_SECRET_KEY);
            const cipherTextBtoa = btoa(cipherText);
            setDisplayPatientResultUrl(`${process.env.REACT_APP_URL}/display_result/${cipherTextBtoa}`);
            setShortDisplayPatientResultUrl(`/display_result/${cipherTextBtoa}`);

            mounted.current = true;
        }
    });

    const handleCopyUrl = () => {
        //navigator.clipboard.writeText(displayPatientResultUrl);
        //window.prompt("Copy to clipboard: Ctrl+C, Enter", displayPatientResultUrl);
        setIsCopied(true);
    }

    const handleRedirectPatientResultUrl = () => {
        window.open(shortDisplayPatientResultUrl);
    }

    const handleDownloadQRCode = () => {
        const canvas = document.querySelector(`.patient-result-Qrcode > canvas`);
        var link = document.createElement('a');
        link.href = canvas.toDataURL();
        link.download = `${patientDetail?.name}.png`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="xs">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    QR CODE
                </ModalHeader>
                <ModalCloseButton />

                <ModalBody pb={2}>
                    <VStack px={2} py={2} align="center" justify="center">
                        <div className={`patient-result-Qrcode`}>
                            <QRCodeCanvas value={displayPatientResultUrl} size={128} />
                        </div>
                        <InputGroup>
                            <Input type='text' placeholder='mysite' value={displayPatientResultUrl} isReadOnly={true}/>
                            <InputRightElement>
                                <IconButton
                                    size="md"
                                    title='Xem kết quả'
                                    icon={<MdOpenInBrowser />}
                                    onClick={() => {
                                            handleRedirectPatientResultUrl();
                                        }
                                    }
                                />
                            </InputRightElement>
                        </InputGroup>
                        { isCopied && <Text color="green.500">Đã copy</Text> }
                        <Button colorScheme='blue' mt={4} onClick={() => handleDownloadQRCode()}>
                            <Icon boxSize={6} as={MdDownload} marginRight="8px"/> 
                            <Text>Tải QR</Text>
                        </Button>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ShowQRCodeModal;